import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
// import {Container} from  




@Entity('post_shipment_details')
export class PostShipmentDetailsEntity {
    @PrimaryGeneratedColumn("increment", { name: 'post_shipment_id' })
    postShipmentId: number;

    @Column("int", {
        nullable: false,
        name: "sale_order_id"
      })
      saleOrderId: number;

  @Column("int", {
    nullable: false,
    name: "vessel_no"
  })
  vesselNo: number;

  @Column("varchar", {
    nullable: false,
    name: "vessel_name"
  })
  vesselName: string;

  
  @Column("varchar", {
    nullable: false,
    name: "marks_no"
  })
  marksNo: string;

  @Column("datetime", {
    nullable: false,
    name: "date_of_issue"
  })
  dateOfIssue: Date;


  @Column("varchar", {
    nullable: false,
    name: "lc_no"
  })
  lcNo: string;


  @Column("varchar", {
    nullable: false,
    name: "lc_name"
  })
  lcName: string;

  @Column("varchar", {
    nullable: false,
    name: "lc_bank_address"
  })
  lcBankAddress: string;



  @Column("int", {
    nullable: false,
    name: "lc_amount"
  })
  lcAmount: number;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;




}